<script lang="ts" setup>
import { goLiveChat } from '@nami/utils'
</script>

<template>
    <div class="live-chat-lg" data-gtm-category="Common" data-gtm-label="Common_LiveChat_Click">
        <button class="liveChat-btn" @click="goLiveChat()">
            {{ $t('live_chat') }}
        </button>
    </div>
    <div style="display: flex;" data-gtm-category="Common" data-gtm-label="Common_LiveChat_Click">
        <a class="live-chat-sm" href="#" @click="goLiveChat()">
            <img alt="live-chat" src="../../assets/images/icon_live_chat_mobile.svg">
            <span class="live-chat-word">
                {{ $t('live_chat') }}
            </span>
        </a>
    </div>
</template>
